export const css = {
	root: '_3_M6A36H',
	input: '_16cEHc6X',
	inputWrapper: 'J5qL-oLQ rhRxNngc _3DZxDnlB',
	checked: '_1TANcYVs',
	focused: '_1M7q7bgR',
	onLabel: '_11AzE5EX',
	offLabel: '_1LNKVWvI',
	disabled: '_2-m1a9NE',
	readonly: 'yxV-ji-P',
	invalid: '_2rxo5FYj',
	valid: '_3HLWgdCO',
	' _key': 'afcpe-theme/afcpe/dojo/checkbox'
};

export default css;
